const useSetLocalStorageLanguage = () => {
  let jsonData = localStorage.getItem('countryData');
  // jsonData가 있거나 언어 선택 값이 없을 때만 설정(보통 초기 접속 시 실행)
  if (jsonData && !localStorage.getItem('selectedLanguage')) {
    const { country } = JSON.parse(jsonData);
    switch (country) {
      case 'KR':
        localStorage.setItem('selectedLanguage', 'ko');
        break;
      case 'JP':
        localStorage.setItem('selectedLanguage', 'jp');
        break;
      default:
        localStorage.setItem('selectedLanguage', 'en');
        break;
    }
  }
};

export default useSetLocalStorageLanguage;
